module.exports = __webpack_public_path__ + "img/house_tour_n.4b4abcd5.png";